export default __webpack_public_path__ + "images/c0c5afff47d2f1adb5fcefa9fecc2da9.png";